// import components
import { styled } from '@mui/material';
import CustomDrawer from 'components/shared/Drawer/Drawer';

export const StyledCustomDrawer = styled(CustomDrawer)(() => ({
  '& .MuiDrawer-paper': {
    width: '400px'
  }
}));
